import {Component} from '@angular/core';
import {AuthService} from '../shared/services/auth.service';
import {ActivatedRoute, Router} from '@angular/router';
import {isUUID} from '../shared/utils/utils';
import {GenericApiResponse} from "@webmate-web-core/shared/api/apibase.api";

@Component({
    selector: 'wm-account-activating',
    templateUrl: './account-activating.component.html',
    styleUrls: ['./account-activating.component.less'],
})
export class AccountActivatingComponent {
    private readonly takingLongAfterSeconds = 20;
    private timeoutHandle?: ReturnType<typeof setTimeout> = undefined;

    takingLong: boolean = false;
    error?: string | GenericApiResponse = undefined;

    constructor(private OAuth2AuthService: AuthService, private route: ActivatedRoute, private router: Router) { /* nothing */
    }

    ngOnInit() {
        let resetToken = this.route.snapshot.queryParamMap.get('reset');
        if (isUUID(resetToken)) {
            //invited users are activated by resetting their PWs using the provided token!
            this.router.navigate(['/confirmreset'], {queryParams: {'reset': resetToken}});
        } else {
            let activateToken = this.route.snapshot.queryParamMap.get('activate');
            if (activateToken && isUUID(activateToken)) {
                this.timeoutHandle = setTimeout(() => {
                    this.takingLong = true;
                }, this.takingLongAfterSeconds * 1000);
                this.OAuth2AuthService.activateUserAccountWithToken(activateToken).subscribe(
                    _ => {
                        clearTimeout(this.timeoutHandle);
                        this.router.navigate(['/activated']);
                    },
                    error => {
                        clearTimeout(this.timeoutHandle);
                        console.error('Error activating user account: ', error);
                        this.error = error.error;
                    }
                );
            } else {
                this.router.navigate(['/login']);
            }
        }
    }
}
